import {RouteDescriptor} from "../../RouteDescriptor";
import {Route} from "../../Route";
import {Role} from "../../../roles/Role";
import {SchedulePageNew} from "../../../../../pages/Lk/OperatorsOnly/Schedule/SchedulePageNew";
import {PageGroupMessages, PageGroups} from "../../pageGroups";
import {defineMessage} from "react-intl";

const ScheduleNewRouteTitleMessage = defineMessage({
  id: "scheduleNewRoute.title",
  defaultMessage: "Schedule New",
})

export const scheduleNew: RouteDescriptor<Route.scheduleNew> = {
  route: Route.scheduleNew,
  render: SchedulePageNew,
  title: ScheduleNewRouteTitleMessage,
  path: '/lk/schedule-new',
  allowRoles: [
    Role.freighterAdmin,
    Role.freighterServiceManager,
    Role.freighterClientManager,
  ],
  redirectToHomeRoles: [
  ],
  showInSidebar: false,
  group: PageGroups.FLEET,
  groupTitle: PageGroupMessages.fleet,
}
